import { Message } from '@patsnap/tahiti-core/common/message';
import { isPsHttpError } from '@patsnap/tahiti-core/common/ps-http';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ErrorHandlerContribution, ErrorHandlerRegistry } from '@patsnap/tahiti-core/common/error-handler-contribution';
import { I18nService } from '@/services/i18n-service';
import { HttpSuccessException } from '@eureka/services/src/exception';
import { prepareInterceptorEdition, UsageAmountWhere, EurekaVersion } from '@eureka/shared/edition-upgrade/src/constants';

@injectable()
export class AirErrorHandler implements ErrorHandlerContribution {
    constructor(
        @inject(Message)
        private readonly _message: Message,
        @inject(I18nService)
        private readonly _i18nService: I18nService
    ) { }

    private _showErrorMessageByCode(code: number) {
        const key = `commonStatusCode.${code || '400'}`;
        const message = this._i18nService.te(key) ? this._i18nService.t(key) : this._i18nService.t('commonStatusCode.400');
        if (message) {
            this._message.error({
                message,
                dangerouslyUseHTMLString: true,
            });
            return true;
        }
        return false;
    }

    registerHandler(handlers: ErrorHandlerRegistry): void {
        handlers.register((error: Error) => {
            const data = error?.cause || error?.data;
            if (prepareInterceptorEdition(data?.error_code)) {
                import('@eureka/shared/edition-upgrade').then(({ invokeEditionUpgrade }) => {
                    invokeEditionUpgrade(UsageAmountWhere.AGENTIC, EurekaVersion.AIR).then((needToast) => {
                        needToast && this._showErrorMessageByCode(data?.error_code);
                    });
                });
                return true;
            }
            return false;
        });

        handlers.register((error: Error) => {
            if (!HttpSuccessException.is(error)) {
                return false;
            }
            const data = error.data;
            return this._showErrorMessageByCode(data.error_code);
        });

        handlers.register((error: Error) => {
            if (!isPsHttpError(error)) {
                console.error('error', error);
                return false;
            }
            const data = error.cause;
            return this._showErrorMessageByCode(data.error_code);
        });

        handlers.register((error: Error) => {
            const data = error.cause;
            if (typeof data?.error_code !== 'number') {
                return false;
            }
            return this._showErrorMessageByCode(data.error_code);
        });
    }
}
